import React from 'react';
import {
  Component,
  Position,
  PuzzleCheckbox,
  VBox
} from "puzzle"
import { CheckboxChangeEvent } from "@progress/kendo-react-inputs";
import classNames from "classnames";
import { STATE, RESPONSE } from "./Types"

class DownloadQuote extends Component<STATE, {}> {

  state: STATE = {
    hasApprovedQuotes: false,
    hasProvidedQuotes: false,
    outputFormats: [],
    downloadApproved: false,
    downloadProvided: false
  };

  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    this.dispatch('updateDownloadQuoteFooter', Position.end, {
      fromAction: this.props.fromAction,
      disableButtons: true
    });
  };

  /**
   * Prepare download params
   * @params format
   */
  getDownloadParams = (format: string) => {
    const { downloadApproved, downloadProvided } = this.state;
    return {
      approvedQuotesSelected: downloadApproved,
      emailEnabled: false,
      outputFormat: format,
      providedQuotesSelected: downloadProvided
    }
  };

  /**
   * Sets quote download data.
   * @param data
   */
  setData = (data: RESPONSE): void => {
    const { hasApprovedQuotes, hasProvidedQuotes, outputFormats } = data;

    this.setState({
      hasApprovedQuotes,
      hasProvidedQuotes,
      outputFormats
    });
  };

  /**
   * On change handler
   * @param event
   */
  onChange = (event: CheckboxChangeEvent): void => {
    const { value } = event;
    const name = event.target.element?.name;
    if (name) {
      let newState: { [key: string]: boolean } = {
        downloadProvided: false,
        downloadApproved: false
      };
      newState[name] = value;

      this.setState({
        ...newState
      }, this.updateDialogFooter)
    }
  };

  /**
   * Updates dialog footer according to state
   */
  updateDialogFooter = (): void => {
    const { downloadApproved, downloadProvided } = this.state;
    this.dispatch('updateDownloadQuoteFooter', '', {
      fromAction: this.props.fromAction,
      disableButtons: !(downloadApproved || downloadProvided)
    })
  };


  renderBody = (): JSX.Element => {
    const { hasProvidedQuotes, hasApprovedQuotes, downloadProvided, downloadApproved } = this.state;
    const providedQuotesClass = classNames('tp-quote-card providedClass', {
      'k-state-disabled': !hasProvidedQuotes
    });
    const approvedQuotesClass = classNames('tp-quote-card approvedClass', {
      'k-state-disabled': !hasApprovedQuotes
    });

    return (
      <VBox gap={6}>
        <div className={providedQuotesClass}>
          <PuzzleCheckbox
            disabled={!hasProvidedQuotes}
            className={'tp-quote-checkbox'}
            label={this.translate('providedQuotes')}
            name={'downloadProvided'}
            checked={downloadProvided}
            onChange={this.onChange}
          />
          <div>{this.translate('providedQuotesDescription')}</div>
        </div>
        <div className={approvedQuotesClass}>
          <PuzzleCheckbox
            disabled={!hasApprovedQuotes}
            className={'tp-quote-checkbox'}
            label={this.translate('approvedQuotes')}
            name={'downloadApproved'}
            checked={downloadApproved}
            onChange={this.onChange}
          />
          <div>{this.translate('approvedQuotesDescription')}</div>
        </div>
      </VBox>
    )
  };

}

export default DownloadQuote;
